export default __webpack_public_path__ + "static/varunFull-35bd75184221a78510d8ed0cc5be28c9.svg";